import React from 'react';
import { Box, Avatar, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * ActivityFeed — feed milestone'ów i świadomych działań (sekcja 8.6).
 * Nie pokazuje każdej synchronizacji kroków.
 */
function ActivityFeed({ items = [] }) {
  const theme = useTheme();

  if (!items.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 4, textAlign: 'center' }}>
        Brak aktywności do wyświetlenia
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      {items.map((item, idx) => (
        <Box
          key={idx}
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1.5,
            py: 1.5,
            px: 2,
            borderRadius: `${theme.tokens?.primitive?.radius?.control ?? 12}px`,
            '&:hover': { bgcolor: theme.palette.action.hover },
            transition: 'background-color 160ms ease',
          }}
        >
          <Avatar
            src={item.avatarUrl}
            sx={{ width: 32, height: 32, fontSize: '0.75rem', fontWeight: 700, bgcolor: 'primary.light', color: 'primary.main' }}
          >
            {item.icon || item.name?.charAt(0)}
          </Avatar>
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              <Typography component="span" sx={{ fontWeight: 700 }}>{item.name}</Typography>
              {' '}{item.action}
              {item.value && (
                <Typography component="span" sx={{ fontWeight: 700, color: 'primary.main' }}>
                  {' '}{item.value}
                </Typography>
              )}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {item.time}
            </Typography>
          </Box>
          {item.badge && (
            <Box
              sx={{
                px: 1,
                py: 0.25,
                borderRadius: `${theme.tokens?.primitive?.radius?.pill ?? 999}px`,
                bgcolor: theme.tokens?.semantic?.surface?.brandTint,
                color: 'primary.main',
                fontSize: '0.6875rem',
                fontWeight: 700,
              }}
            >
              {item.badge}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
}

export default ActivityFeed;
